import { prospectApi } from 'api/api';
import { useMemo } from 'react';
import { useAppSelector } from 'store';
import './ProspectAmountSummary.scss';

export const useProspectFromState = () => {
  const prospectId = useAppSelector(state => state.app.prospectId);

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const { data: prospect } = prospectApi.useGetProspectQuery(prospectId!, {
    skip: !prospectId,
  });
  return prospect;
};

export const ProspectAmountSummary = () => {
  const prospect = useProspectFromState();
  const totalQuantity = useMemo(
    () => prospect?.rows.reduce((acc, row) => acc + row.quantity, 0) ?? 0,
    [prospect]
  );
  return (
    <div className="ProspectAmountSummary tw-text-secondary tw-px-8 tw-flex-col tw-justify-between tw-text-sm">
      {/* <div>Total</div> */}
      <div className="tw-flex tw-justify-between">
        <div>Antal</div>
        {totalQuantity > 0 && (
          <div data-testid="total-amount">{totalQuantity}</div>
        )}
      </div>
      {/* <div className="tw-flex tw-justify-between">
        <div>Rekommenderat pris (SEK)</div>
        <div>{}</div>
      </div> */}
    </div>
  );
};

export default ProspectAmountSummary;
